(ns ^:dev/always bp-clients.tv-app.api.graphql.castle
  (:require
   [bp-clients.tv-app.api.graphql.utils :refer [query-builder]]
   [graphql-builder.core :as graphql-builder])
  (:require-macros [graphql-builder.parser :refer [defgraphql]]))

(defgraphql graphql-raw-queries
  "graphql/castle/keep_watching.graphql")

(def ^:private query-map (graphql-builder/query-map graphql-raw-queries))
(def ^:private keep-watching-raw (get-in query-map [:query :tv-app-keep-watching]))

(defn keep-watching-query
  "Sends a token-valid query"
  ([]
   (query-builder keep-watching-raw {})))

(comment
  ;; see the corresponding .graphql files for more impormation
  (keep-watching-query))
